<template>
  <pc-block>
    <div class="pc-messages">
      <div class="pc-block__title">
        <div>
          {{ $t('pc.messages.title') }}
          <div :class="{'active':showNonRead}" class="pc-messages__switch">
            {{ $t('pc.messages.show-only-nonread') }} <pc-radio-switcher v-model="showNonRead"></pc-radio-switcher>
          </div>
        </div>
        <pc-button
          variant="dark"
          class="mark-read"
          :disabled="!messages.length"
          @click="markAllAsRead"
        >
          {{ $t('pc.messages.mark-as-read') }}
        </pc-button>
      </div>
      <div v-if="isLoading" class="loader-wrap">
        <div class="lds-ring">
          <div></div><div></div><div></div><div></div>
        </div>
      </div>
      <div v-else class="pc-messages__list">
        <div
          v-for="message in preparedMessages"
          :key="message.id"
          :class="{'is_new': message.just_added}"
          class="pc-messages__item"
        >
          <div class="pc-messages__item-wrap">
            <div class="pc-messages__message" :class="{'is-read': message.was_read || message.opened, 'opened': message.opened}">

              <div class="pc-messages__title" @click="toggleMessage(message.id)">
                <div class="pc-read-status"></div>{{ message.title }}
              </div>
              <div class="pc-messages__text" v-html="message.text" />
            </div>
            <div class="pc-messages__info">
              <div class="pc-messages__date">
                {{ dateFormat(message.received) }}
              </div>
              <div class="pc-messages__type">
                {{ $t(`pc.messages.${message.message_type}`) }}
              </div>
            </div>
          </div>
          <div v-if="!message.opened" class="pc-messages__show-more" @click="toggleMessage(message.id)">
            {{ $t('pc.messages.press-to-read') }}
          </div>
        </div>
      </div>
    </div>
  </pc-block>
</template>

<script>
import PcBlock from '@/components/views/PrivateCabinet/PcBlock'
import PcRadioSwitcher from '@/components/common/PcSwitcher'
import {api} from '@/api/api'
import {mapActions, mapGetters} from 'vuex'
import PcButton from '@/components/common/PcButton.vue'
import IcuLoader from '@/components/common/IcuLoader.vue'


export default {
  name: 'PcMessages',
  components: {IcuLoader, PcButton, PcRadioSwitcher, PcBlock},
  data() {
    return {
      isLoading: true,
      showNonRead: false,
      messages: [],
      limit: 20,
      offset: 0,
      hasNextPage: false,
      isUpdating: false,
    }
  },
  masonry: null,
  computed: {
    ...mapGetters(['haveNewMessage']),
    preparedMessages() {
      return this.messages
    }
  },
  watch:{
    showNonRead(){
      this.getMessages()
      this.messages.forEach(el => {
        if(el.opened) {
          el.opened = false
          el.was_read = true
        }
      })
    },
    haveNewMessage(newVal){
      if(newVal) {
        this.getMessages(false, true)
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('setHaveNewMessage', false)
    await this.getMessages()
    this.isLoading = false
    this.$options.masonry = document.querySelector('.pc-content')
    this.$options.masonry.addEventListener('scroll', this.addScrollEvent)
  },
  beforeDestroy() {
    this.$options.masonry.removeEventListener('scroll', this.addScrollEvent)
  },
  methods: {
    ...mapActions(['setHasUnreadMessages']),
    addScrollEvent() {
      if (this.$options.masonry.scrollTop + this.$options.masonry.clientHeight >= this.$options.masonry.scrollHeight -1) {
        if (this.hasNextPage && !this.isUpdating) {
          this.getMessages(true)
        }
      }
    },
    async toggleMessage(id){
      const index = this.messages.findIndex(el => el.id === id)
      if (!this.messages[index].opened) {
        try {
          this.$set(this.messages[index], 'opened', true)
          this.$set(this.messages[index], 'was_read', true)
          const {data} = await api.cabinet.setMessageAsRead(id)
          await this.$store.dispatch('setHasUnreadMessages', data.unread_messages)

        } catch (err) {
          this.$toast.error(this.$t('notifications.something-went-wrong'))
          console.log(err)
        }
      } else {
        this.messages[index].opened = false
      }
    },
    async getMessages(getNext = false, firstMessageOnly=false) {
      this.isUpdating = true
      if(getNext){
        ++this.offset
      } else {
        if(!firstMessageOnly) {
          this.offset = 0
        }
      }
      const params = {
        limit: this.limit,
        offset: firstMessageOnly ? 0 : this.offset*this.limit
      }

      if(this.showNonRead){
        params.unread = true
      }
      try {
        const { data } = await api.cabinet.getMessages(params)
        this.isUpdating = false
        if(getNext) {
          this.messages.push(...data.results)
        }else {
          if(firstMessageOnly) {
            const newMessage = data.results[0]
            newMessage.just_added = true
            if(!(this.messages.length % this.limit)) {
              if(data.count - this.messages.length === 1) {
                this.hasNextPage = true
              }
              this.messages.pop()

            }
            this.messages.unshift(newMessage)

            await this.$store.dispatch('setHaveNewMessage', false)
            setTimeout(() =>{
              newMessage.just_added = false
            }, 100)
          }else {
            this.$set(this, 'messages', data.results)
          }
        }
        await this.$store.dispatch('setHasUnreadMessages', data.is_unread)
        if(!firstMessageOnly) {
          this.hasNextPage = !!data.next
        }
      }catch(err) {
        console.log(err)
        this.$toast.error(this.$t('notifications.something-went-wrong'))
      }
    },
    dateFormat(value) {
      const date = new Date(value)
      return date.toLocaleString('ua-UA')
    },

    async markAllAsRead() {
      try {
        this.messages.forEach(el => {
          this.$set(el, 'was_read', true)
        })
        await api.cabinet.setAllMessagesAsRead()
        await this.setHasUnreadMessages(false)
      }catch(err) {
        console.log(err)
      }
    }

  }

}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.pc-messages {

  .pc-block__title {
    display: flex;
    justify-content: space-between;
  }

  &__switch {
    font-size: 15px;
    font-weight: 400;
    display: flex;
    align-items: center;
    color: $passive-text;
    margin-top: 15px;

    &.active {
      color: $default-text;
    }
  }

  &__item {
    padding: 12px;
    interpolate-size: allow-keywords;
    transition: opacity 1.5s, height 1s, padding 1s;
  }
  &__item-wrap {
    display: flex;
    justify-content: space-between;
  }


  &__title {
    font-size: 16px;
    font-weight: 700;
    display: flex;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  &__text {
    padding-left: 20px;
    overflow: hidden;
    height: 20px;
    word-wrap: anywhere;
  }

  .pc-read-status {
    display: flex;
    width: 20px;
    padding: 4px 10px 0 0;
    &:after {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      background: $error-text;
    }
  }

  &__show-more {
    margin-left: 20px;
    margin-top: 10px;
    font-size: 12px;
    color: $passive-text;
    cursor: pointer;

  }

  &__info {
    flex-shrink: 0;
    padding-left:46px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    color: $passive-text;
    font-size: 14px;
  }

  &__date {
    color: $passive-text;
    padding-bottom: 10px;
  }

  &__type {
    color: $passive-text;
    padding-left: 30px;
    line-height: 1.4;
    background-image: url("~@/assets/img/components/common/IcuIcon/pc-warning-small.svg");
    background-repeat: no-repeat;
    background-position: left center;
  }

  &__message {
    &.is-read {
      .pc-messages__title, .pc-messages__text {
        color: $passive-text
      }

      .pc-read-status {
        width: 20px;
        flex-shrink: 0;
        &:after {
          content: none;
        }
      }
    }
    &.opened {
      .pc-messages__text {
        color: $default-text;
        height: auto;
      }

      .pc-messages__title {
        color: $default-text;
      }
    }
  }

  @media (max-width: $tablet) {
    .pc-messages {
      &__item-wrap {
        display: block;
      }

      &__info {
        flex-direction: row;
        align-items: center;
        padding-left: 20px;
        padding-top: 10px;
      }

      &__item {
        padding: 12px 0;
      }

      &__date {
        padding: 0 0 0 10px;
        order: 2;
      }

    }

    .pc-block__title {
      flex-direction: column;
      align-items: flex-start;
    }

    &__switch {
      margin-top: 32px;
    }
  }

}

.is_new {
  padding: 0 12px;
  height: 0;
  opacity: 0;
}
.mark-read {
  height: 40px;
  min-height: 40px;
  padding-left: 80px;
  padding-right: 80px;

  @media (max-width: $tablet) {
    width: 100%;
    margin-top: 30px;
    padding-left: 5px;
    padding-right: 5px;
  }
}

.loader-wrap {
  display: flex;
  justify-content: center;
}
.lds-ring {
  display: inline-block;
  position: relative;
  opacity: 0.5;
  width: 80px;
  height: 80px;
  margin: 0 auto;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #73BEE7 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
